<template>
    <a-modal title="客源信息" :visible="is_modal_tourist" centered @cancel="tourist_cancel" @ok="tourist_ok">
      <a-form-model :model="form_tourist" :rules="is_modalrules" ref="form_tourist">
        <a-form-model-item label="姓名" prop="lesseeName">
          <a-input v-model="form_tourist.lesseeName" />
        </a-form-model-item>
        <a-form-model-item label="电话" prop="lesseePhone">
          <a-input v-model="form_tourist.lesseePhone" />
        </a-form-model-item>
        <a-form-model-item label="品牌名称" prop="lesseeBrandName">
          <a-input v-model="form_tourist.lesseeBrandName" />
        </a-form-model-item>
        <a-form-model-item label="身份证/统一社会编码" prop="lesseeCardNo">
          <a-input v-model="form_tourist.lesseeCardNo" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
</template>

<script>
import {
  edit_contractLessee
} from '@/api/system/contract'
export default {
    data () {
        // 电话号码正则
        const validatePhone = async (rule, value, callback) => {
            const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
            if (value === undefined || value === '') {
                callback()
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确格式的手机号码!'))
            } else {
                callback()
            }
        }
        return {
            is_modal_tourist: false,
            form_tourist: {
                id: 0, // 合同ID
                lesseeBrandName: '',
                lesseeCardNo: '',
                lesseeName: '',
                lesseePhone: ''
            },
            is_modalrules: {
                lesseeName: [
                    { required: true, message: '姓名不能为空', trigger: 'blur' },
                    { min: 1, max: 7, message: '长度2-7位', trigger: 'blur' }
                ],
                lesseePhone: [
                    { required: true, message: '电话不能为空', trigger: 'blur' },
                    { validator: validatePhone, trigger: 'blur' }
                ],
                lesseeBrandName: [
                    { required: true, message: '品牌名称不能为空', trigger: 'blur' },
                    { min: 1, max: 7, message: '长度2-7位', trigger: 'blur' }
                ],
                lesseeCardNo: [{ required: true, message: '证件号码不能为空', trigger: 'blur' }]
            }
        }
    },
    methods: {
         // 取消-关闭---客
        tourist_cancel () {
            this.$refs.form_tourist.resetFields()
            this.is_modal_tourist = false
        },
        // 提交---客
        tourist_ok () {
            this.$refs.form_tourist.validate((valid) => {
                if (valid) {
                    edit_contractLessee(this.form_tourist).then((res) => {
                        if (res.code === 200) {
                            this.$message.success('修改成功')
                            this.$emit('onSuccess')
                            this.tourist_cancel()
                        }
                    })
                } else {
                    return false
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>

</style>